import { render } from "./FormUser.vue?vue&type=template&id=2f4854d2&ts=true"
import script from "./FormUser.vue?vue&type=script&lang=ts"
export * from "./FormUser.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__